































import { library } from '@fortawesome/fontawesome-svg-core';
import { faCode } from '@fortawesome/pro-light-svg-icons';
library.add(faCode);

import BaseTable from '../Common/Mixins/BaseTable.vue';
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Site, DataLoaderParams } from '@/types';
import { userSvc } from '@/services';

@Component({ name: 'users-table' })
export default class UsersTable extends mixins(BaseTable) {
  title: string | null = 'Team Members';
  dataKey: string = 'users';
  itemPK: string = 'id';
  sortBy: string = 'name';
  protected withDateRange: boolean = false;

  showCode: boolean = false;

  fields: object = {
    name: { label: 'Name' },
    roles: { label: 'Roles' },
    status: { label: 'Status' }
  };

  async dataLoader(params: DataLoaderParams): Promise<any> {
    return await userSvc.getUsers(params);
  }
}
